import { Stack, Button, Tooltip } from '@mui/material';

import { useUIContext } from '@/shared/context/UIContextProvider';

export type ButtonType = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  hidden?: boolean;
  confirmDialog?: {
    title: string;
    description: string;
  };
  tooltip?: string;
};

export type ConfirmButtonsProps = {
  confirm: ButtonType;
  cancel: ButtonType;
  save?: ButtonType;
  gap?: string;
  justifyContent?: string;
  alignItems?: string;
};

export function ConfirmButtons({
  confirm,
  cancel,
  save,
  gap,
  justifyContent,
  alignItems,
}: ConfirmButtonsProps) {
  const { onClick: clickConfirm } = confirm;
  const { onClick: clickCancel } = cancel;
  const { onClick: clickSave } = save || { onClick: () => {} };

  const { openConfirm } = useUIContext();

  const handleClickConfirm = () => {
    if (confirm.confirmDialog) {
      openConfirm({
        title: confirm.confirmDialog.title,
        description: confirm.confirmDialog.description,
        onAction: (value: boolean) => {
          if (value) {
            clickConfirm();
          }
        },
      });
    } else {
      clickConfirm();
    }
  };

  const handleClickCancel = () => {
    if (cancel.confirmDialog) {
      openConfirm({
        title: cancel.confirmDialog.title,
        description: cancel.confirmDialog.description,
        onAction: (value: boolean) => {
          if (value) {
            clickCancel();
          }
        },
      });
    } else {
      clickCancel();
    }
  };

  return (
    <Stack
      direction="row"
      alignItems={alignItems || 'center'}
      justifyContent={justifyContent || 'space-between'}
      gap={gap || '12px'}
      className="h-[28px]"
    >
      {save && !save.hidden ? (
        <Tooltip title={cancel.tooltip || ''}>
          <Button
            variant="outlined"
            onClick={clickSave}
            color="primary"
            disabled={save.disabled}
            className="h-32 min-w-[112px] !border-white/20 !text-stone-200 hover:!bg-white/5"
          >
            {save.label}
          </Button>
        </Tooltip>
      ) : null}
      {!confirm.hidden ? (
        <Tooltip title={confirm.tooltip || ''}>
          <span>
            <Button
              variant="contained"
              onClick={handleClickConfirm}
              color="primary"
              disabled={confirm.disabled}
              className="h-32 min-w-[112px] !bg-blue-500 px-16 !text-white hover:!bg-blue-600"
            >
              {confirm.label}
            </Button>
          </span>
        </Tooltip>
      ) : null}
      {!cancel.hidden ? (
        <Tooltip title={cancel.tooltip || ''}>
          <Button
            variant="outlined"
            onClick={handleClickCancel}
            color="primary"
            disabled={cancel.disabled}
            className="h-32 min-w-[112px] !border-white/20 !text-stone-200 hover:!bg-white/5"
          >
            {cancel.label}
          </Button>
        </Tooltip>
      ) : null}
    </Stack>
  );
}
